<router-outlet class="hidden is-prod-{{environment}}"></router-outlet>
